// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__+Y5Hc","brand":"Nav_brand__rMvbx"};